"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function PoliciesLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  // The Contact Us page is a full-width showcase landing page with its own navigation and styling.
  if (pathname?.startsWith("/policies/contact-us")) {
    return <>{children}</>;
  }

  return (
    <div className="container max-w-4xl mx-auto py-12 px-4 md:px-6">
      <div className="mb-10 mt-[6rem]">
        <h1 className="text-3xl font-bold mb-2">Legal & Policies</h1>
        <div className="border-b pb-4 mb-6">
          <nav className="flex gap-4 overflow-x-auto text-sm font-medium text-muted-foreground">
            <Link
              href="/policies/privacy-policy"
              className={cn(
                "whitespace-nowrap pb-2 transition-colors hover:text-primary",
                pathname === "/policies/privacy-policy" &&
                  "border-b-2 border-primary text-primary font-semibold",
              )}
            >
              Privacy Policy
            </Link>
            <Link
              href="/policies/terms-conditions"
              className={cn(
                "whitespace-nowrap pb-2 transition-colors hover:text-primary",
                pathname === "/policies/terms-conditions" &&
                  "border-b-2 border-primary text-primary font-semibold",
              )}
            >
              Terms & Conditions
            </Link>
            <Link
              href="/policies/cancellation-refund"
              className={cn(
                "whitespace-nowrap pb-2 transition-colors hover:text-primary",
                pathname === "/policies/cancellation-refund" &&
                  "border-b-2 border-primary text-primary font-semibold",
              )}
            >
              Cancellation & Refund
            </Link>
            {/* <Link
              href="/policies/shipping-delivery"
              className={cn(
                "whitespace-nowrap pb-2 transition-colors hover:text-primary",
                pathname === "/policies/shipping-delivery" &&
                  "border-b-2 border-primary text-primary font-semibold",
              )}
            >
              Shipping & Delivery
            </Link> */}
            <Link
              href="/policies/contact-us"
              className={cn(
                "whitespace-nowrap pb-2 transition-colors hover:text-primary",
                pathname === "/policies/contact-us" &&
                  "border-b-2 border-primary text-primary font-semibold",
              )}
            >
              Contact Us
            </Link>
          </nav>
        </div>
      </div>
      <div className="prose max-w-none dark:prose-invert">{children}</div>
    </div>
  );
}
